import { render, staticRenderFns } from "./buildingGiftRecord.vue?vue&type=template&id=631035a0&scoped=true"
import script from "./buildingGiftRecord.vue?vue&type=script&lang=js"
export * from "./buildingGiftRecord.vue?vue&type=script&lang=js"
import style0 from "./buildingGiftRecord.vue?vue&type=style&index=0&id=631035a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631035a0",
  null
  
)

export default component.exports